import loadReduxAction from 'modules/redux/actions/load'
import {
  PLANS_ACTION,
  PLANS_ENDPOINT,
  PLANS_PATH
} from 'modules/plan/redux/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import getQuerySearchSelect from 'modules/search/selectors/get-query'
import { logUtil } from 'packages/src'
import getDomainListPathFromQueryReduxUtil from 'modules/redux/utils/get-domain-list-path-from-query'
import getTagPlansSelect from 'modules/plan/redux/selectors/get-tag/index.js'
import getDomainListPathFromTagReduxUtil from 'modules/redux/utils/get-domain-list-path-from-tag/index.js'
import getTagFromMatchRouteUtil from 'modules/routes/utils/get-tag-from-match/index.js'
import { getPaginationLimitAppSelect } from 'modules/app/selectors/getPaginationLimit/index.js'

/**
 * @param options
 * @param match
 * @param ignoreTag
 * @param queryParams
 * @returns {(function(*, *): Promise<void>)|*}
 */
function loadRecommendedPlansAction ({
  options,
  match,
  ignoreTag,
  queryParams = {}
} = {}) {
  return async (dispatch, getState) => {
    try {
      const query = getQuerySearchSelect(getState())
      const tag = (
        getTagPlansSelect(getState()) ||
        getTagFromMatchRouteUtil(match)
      )
      const debugProps = {
        query,
        tag
      }
      logUtil('loadRecommendedPlansAction').debug('[start] debugProps=', debugProps)

      if (!queryParams.limit) {
        queryParams.limit = getPaginationLimitAppSelect(getState())
      }

      let domainListPath = PLANS_PATH.RECOMMENDED
      if (query) {
        queryParams.q = query
        domainListPath = getDomainListPathFromQueryReduxUtil(domainListPath, query)
      }

      if (!ignoreTag) {
        queryParams.tag = tag
        domainListPath = getDomainListPathFromTagReduxUtil(domainListPath, tag)
      }

      const endpoint = getEndpointTrainingUtil(
        PLANS_ENDPOINT.LOAD_RECOMMENDED,
        queryParams
      )

      await dispatch(
        loadReduxAction({
          type: PLANS_ACTION.LOAD_RECOMMENDED,
          payload: {
            endpoint,
            domainListPath
          },
          options
        })
      )
    } catch (error) {
      logUtil('loadRecommendedPlansAction').error('error=', error)
    }
  }
}

export default loadRecommendedPlansAction
